import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function LatestArticles() {
  const latestArticles = articles.slice(0, 6);

  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            最新分析文章
          </h2>
          <p className="text-sm text-foreground-600 mt-1">专业团队为您深度解读每一场赛事</p>
        </div>
        <Link
          to="/category/football"
          className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap"
        >
          查看全部 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {latestArticles.map((article) => (
          <Link
            key={article.id}
            to={`/article/${article.id}`}
            className="group bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-200 transition-all overflow-hidden"
          >
            <div className="relative h-48 overflow-hidden">
              <img
                src={article.imageUrl}
                alt={article.title}
                title={`好博体育 - ${article.title}`}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500 text-white text-xs font-medium rounded-full">
                {article.categoryName}
              </span>
            </div>
            <div className="p-5">
              <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                {article.title}
              </h3>
              <p className="text-sm text-foreground-600 line-clamp-2 mb-4 leading-relaxed">
                {article.excerpt}
              </p>
              <div className="flex items-center justify-between text-xs text-foreground-500">
                <span>{article.author}</span>
                <div className="flex items-center gap-3">
                  <span>{article.date}</span>
                  <span>{article.readTime}</span>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}